// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"ea4449e2","361":"b981df2a","511":"99ab0c45","767":"ab153078"}[chunkId] + ".chunk.js";
};